import { subDays } from "date-fns";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import { WEB_BASE_URL } from "./webbase";
import cookie from "react-cookies";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";

export default function Transaction() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [transactionType, setTransactionType] = useState("All"); // Default: All
  const [transactionDetails, setTransactionDetails] = useState([]);
  const token = cookie.load("token");
  const [vasWallet, setVasWallet] = useState(0);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 50;

  useEffect(() => {
    axios
      .get(WEB_BASE_URL + "/onboarding/account-balance", {
        headers: { authorization: token },
      })
      .then((res) => {
        setVasWallet(res.data.data.unicardBalance || 0);
      })
      .catch((err) => console.log(WEB_BASE_URL + " " + err));
  }, [token]);

  useEffect(() => {
    const formattedStartDate = startDate.toISOString().slice(0, 10);
    const formattedEndDate = endDate.toISOString().slice(0, 10);

    axios
      .get(
        `${WEB_BASE_URL}/merchant/unicard-custom-report?endDate=${formattedEndDate}&startDate=${formattedStartDate}`,
        { headers: { authorization: token } }
      )
      .then((res) => {
        if (res.data.status === "2000") {
          let reports = res.data.report?.reverse() || [];

          // Filter by transaction type
          if (transactionType !== "All") {
            reports = reports.filter((item) =>
              transactionType === "Used" ? item.used : !item.used
            );
          }

          setTransactionDetails(reports);
        }
      })
      .catch((err) => console.log(WEB_BASE_URL + " " + err));
  }, [token, startDate, endDate, transactionType]);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN",
  });

  // **Pagination Logic**
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = transactionDetails.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(transactionDetails.length / recordsPerPage);

  return (
    <div>
      <main className="page-content">
        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div className="ms-auto">
            <button type="button" className="btn btn-primary">
              Wallet Balance: &#8358;{formatter.format(vasWallet)}
            </button>
          </div>
        </div>

        {/* Filter Section */}
        <div className="card">
          <div className="card-body">
            <form className="row">
              <div className="col-md-4">
                <label className="form-label">Transaction Start Date:</label>
                <DatePicker
                  selected={startDate}
                    minDate={subDays(new Date(), 60)}
                    maxDate={endDate}
                  onChange={(date) => setStartDate(date)}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Transaction End Date:</label>
                <DatePicker
                  selected={endDate}
                    minDate={startDate}
                    maxDate={new Date()}
                  onChange={(date) => setEndDate(date)}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Transaction Type</label>
                <select
                  className="form-select"
                  value={transactionType}
                  onChange={(e) => setTransactionType(e.target.value)}
                >
                  <option value="All">All</option>
                  <option value="Used">Used</option>
                  <option value="Unused">Unused</option>
                </select>
              </div>
            </form>
          </div>
        </div>

        {/* Export Button */}
        <div className="card">
          <div className="card-body">
            <CSVLink data={transactionDetails} filename={"Unicard Report.csv"}>
              <button className="btn btn-primary">Download Report</button>
            </CSVLink>
          </div>
        </div>

        {/* Transaction Table */}
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Value</th>
                    <th>Unit Price</th>
                    <th>User ID</th>
                    <th>Transaction Date</th>
                    <th>Merchant Account ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.map((e, index) => (
                    <tr key={index}>
                      <td>{e.id}</td>
                      <td>{e.value}</td>
                      <td>{e.unitPrice}</td>
                      <td>{e.userId}</td>
                      <td>{e.dateCreated ? new Date(e.dateCreated).toLocaleString() : "-"}</td>
                      <td>{e.merchantAccountId}</td>
                      <td>{e.used ? "Used" : "Unused"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <nav className="float-end mt-3">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                    Previous
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </main>
    </div>
  );
}
